import { BottomSheetModal, useModal } from "@becon-team/becon-fe-lib/my-modal";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { SvgCable, SvgWifi } from "assets/svg/Icon";
import { useScalpShooting } from "bridge/hooks/(useScalpShotting)";
import { scannerState } from "bridge/store/scannerState";
import { modalIds } from "libs/my-modal";
import { useSelector } from "react-redux";
import { useRecoilValue } from "recoil";
import { RootState } from "store/redux/modules";

/** TODO: REMOVE */
export const ScannerModeModal = () => {
  const modalId = modalIds["scanner-mode"];
  const { t } = useTranslation();
  const { activeUser } = useSelector((state: RootState) => ({
    activeUser: state.user && state.user.users ? state.user.users[0] : null,
    account: state.account.account,
  }));
  const userId = activeUser?.user_id;
  const userNickname = activeUser?.nickname;

  const { modal, closeModal } = useModal(modalId);
  const { isOpened } = modal;
  const scannerStatus = useRecoilValue(scannerState)?.connectStatus;
  const { scalpShooting } = useScalpShooting();

  return (
    <BottomSheetModal closeModal={closeModal} isOpened={isOpened} isCloseModalOutsideClick={true}>
      <div className="p-inner-padding pt-0 space-y-sp-24">
        <div className="text-center font-bold text-lg">{t("스캐너 연결 방법을 선택해주세요")}</div>
        <div className="flex gap-sp-12 w-full">
          <button
            className="rounded-md shadow text-md p-sp-24 font-medium flex flex-col items-center gap-sp-12 w-[50%]"
            onClick={() => {
              scalpShooting({
                userId,
                userNickname,
                currentAction:
                  scannerStatus === "needBluetoothConnect" ? "DevicePairingBluetooth" : "DevicePairingCable",
                nextAction: scannerStatus === "needBluetoothConnect" ? "DevicePairingCable" : undefined,
              });
            }}
          >
            {t("케이블 연결")}
            <SvgCable />
          </button>
          <button
            className="rounded-md shadow text-md p-sp-24 font-medium flex flex-col items-center gap-sp-12 w-[50%]"
            onClick={() => {
              scalpShooting({
                userId,
                userNickname,
                currentAction:
                  scannerStatus === "needBluetoothConnect" ? "DevicePairingBluetooth" : "DevicePairingWifi",
                nextAction: scannerStatus === "needBluetoothConnect" ? "DevicePairingWifi" : undefined,
              });
            }}
          >
            {t("무선 연결")}
            <SvgWifi />
          </button>
        </div>
      </div>
    </BottomSheetModal>
  );
};

export const useScannerModeModal = () => {
  const { modal, openModal, closeModal } = useModal(modalIds["scanner-mode"]);

  const openModalCallback = useCallback(() => {
    openModal();
  }, [openModal]);

  return {
    openModal: openModalCallback,
    closeModal,
    isOpened: modal.isOpened,
  };
};
